// ADULTS
export let ADULTS = 0
// KIDS
export let KIDS = 1